import {useCallback, useEffect} from 'react';
import useLocalStorage from '../lib/useLocalStorage';
import {
    defaultRealtimeVoice,
    normalizeRealtimeVoice,
    type RealtimeVoice
} from './realtimeVoices';

const voiceStorageKey = 'voice-assistant-realtime-voice';

export const useRealtimeVoicePreference = () => {
    const [storedVoice, setStoredVoice] = useLocalStorage<string>(
        voiceStorageKey,
        defaultRealtimeVoice
    );
    const selectedVoice = normalizeRealtimeVoice(storedVoice);

    useEffect(() => {
        if (storedVoice !== selectedVoice) {
            setStoredVoice(selectedVoice);
        }
    }, [selectedVoice, setStoredVoice, storedVoice]);

    const setSelectedVoice = useCallback(
        (voice: RealtimeVoice) => {
            setStoredVoice(voice);
        },
        [setStoredVoice]
    );

    return {selectedVoice, setSelectedVoice};
};
